import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SEOHead from '@/components/feature/SEOHead';

export default function AboutPage() {
  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://36manhua.com' },
      { '@type': 'ListItem', position: 2, name: '关于我们', item: 'https://36manhua.com/about' },
    ],
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '36漫画网',
    url: 'https://36manhua.com',
    description: '优质漫画在线阅读平台，提供海量漫画全集免费阅读服务。36漫画网支持洞洞杂货铺漫画全集在线免费阅读。',
    foundingDate: '2020',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'contact@36manhua.com',
      availableLanguage: ['Chinese'],
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '洞洞杂货铺漫画可以在线免费阅读吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的，36漫画网平台上的洞洞杂货铺漫画全集可以在线免费阅读。我们提供高清画质、流畅的阅读体验，无需付费即可畅享全部章节。',
        },
      },
      {
        '@type': 'Question',
        name: '洞洞杂货铺漫画多久更新一次？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '洞洞杂货铺漫画通常每周更新一话，具体更新时间请关注36漫画网的最新更新列表。我们会第一时间同步更新。',
        },
      },
      {
        '@type': 'Question',
        name: '36漫画网支持哪些设备阅读漫画？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '36漫画网支持电脑、平板和手机等多种设备阅读。无论您使用什么设备，都能获得优质的漫画阅读体验。',
        },
      },
      {
        '@type': 'Question',
        name: '如何找到自己喜欢类型的漫画？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过36漫画网的分类导航，选择热血、搞笑、恋爱、奇幻、悬疑、日常、治愈等不同类别，快速找到自己喜欢的漫画类型。',
        },
      },
    ],
  };

  return (
    <>
      <SEOHead
        title="关于我们"
        description="了解36漫画网——优质漫画在线阅读平台。洞洞杂货铺漫画品牌介绍、用户口碑、联系方式。致力于为漫画爱好者提供免费优质的在线阅读体验。"
        keywords="关于36漫画网,洞洞杂货铺漫画,在线免费阅读,联系36漫画网"
        canonicalUrl="https://36manhua.com/about"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <Breadcrumb items={[{ label: '关于我们' }]} />

            <section className="py-6">
              <div className="text-center mb-10">
                <h1 className="text-3xl md:text-4xl font-heading text-foreground-900 mb-3">关于36漫画网</h1>
                <p className="text-sm text-foreground-600 max-w-2xl mx-auto">
                  致力于为漫画爱好者提供优质、免费、便捷的在线阅读体验
                </p>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-12">
                <div className="lg:col-span-2">
                  <div className="bg-secondary-50 rounded-lg p-6 md:p-8">
                    <h2 className="text-xl font-heading text-foreground-900 mb-4">品牌介绍</h2>
                    <div className="text-sm text-foreground-700 leading-relaxed space-y-4">
                      <p>
                        36漫画网成立于2020年，是国内领先的漫画在线阅读平台。我们致力于为广大漫画爱好者提供海量优质漫画资源，让每一位读者都能享受到便捷、流畅、免费的漫画阅读体验。
                      </p>
                      <p>
                        平台主打作品<strong>《洞洞杂货铺》</strong>是一部温暖治愈的奇幻日常漫画，由夏天岛工作室倾心创作。故事围绕一家神秘的杂货铺展开——在这里，每一件物品都藏着一段奇妙的故事，店主阿洞能听见物品的"心声"，为每一位顾客递上最需要的那件物品。自连载以来，《洞洞杂货铺》凭借其独特的设定、细腻的画风和温馨的剧情，收获了数百万读者的喜爱。
                      </p>
                      <p>
                        除了<strong>洞洞杂货铺漫画</strong>外，我们还提供热血、搞笑、恋爱、奇幻、悬疑、日常、治愈等多种类型的漫画全集在线免费阅读。平台每日更新，确保读者第一时间看到最新连载。
                      </p>
                      <p>
                        36漫画网支持电脑、平板和手机多端阅读，无论您身在何处，都能随时随地畅享追漫乐趣。我们始终坚信：好漫画应该让更多人看到，因此平台所有漫画均为免费阅读。
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-background-50 border border-background-200 rounded-lg p-6 md:p-8">
                  <h2 className="text-xl font-heading text-foreground-900 mb-4">平台数据</h2>
                  <div className="space-y-4">
                    {[
                      { value: '500万+', label: '月活跃读者' },
                      { value: '10,000+', label: '漫画作品' },
                      { value: '99.7%', label: '用户好评率' },
                      { value: '4年+', label: '持续运营时间' },
                    ].map((stat, i) => (
                      <div key={i} className="text-center p-3 rounded-lg bg-secondary-50">
                        <div className="text-2xl font-heading text-primary-500">{stat.value}</div>
                        <div className="text-xs text-foreground-600 mt-1">{stat.label}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div id="reputation" className="mb-12">
                <h2 className="text-2xl font-heading text-foreground-900 mb-6 text-center">用户口碑</h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  {[
                    {
                      name: '小猫咪爱漫画',
                      avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20girl%20avatar%20with%20cat%20ears%20soft%20pink%20hair%20big%20sparkly%20eyes%20cheerful%20expression%20simple%20clean%20background%20chibi%20style%20illustration&width=80&height=80&seq=avatar-01&orientation=squarish',
                      text: '洞洞杂货铺真的太治愈了！每次看完都觉得心里暖暖的，阿洞和那只小橘猫太可爱了。已经推荐给身边所有朋友了！',
                      rating: 5,
                    },
                    {
                      name: '热血少年阿飞',
                      avatar: 'https://readdy.ai/api/search-image?query=Cool%20anime%20style%20boy%20avatar%20with%20spiky%20dark%20hair%20determined%20expression%20wearing%20a%20red%20headband%20simple%20clean%20background%20chibi%20style%20illustration&width=80&height=80&seq=avatar-02&orientation=squarish',
                      text: '36漫画网的更新速度真的快！每次都能第一时间看到最新话，画质也很清晰。热血江湖录追了两年了，超好看！',
                      rating: 5,
                    },
                    {
                      name: '花与梦的读者',
                      avatar: 'https://readdy.ai/api/search-image?query=Gentle%20anime%20style%20girl%20avatar%20with%20long%20brown%20hair%20holding%20a%20book%20warm%20kind%20smile%20simple%20clean%20background%20chibi%20style%20illustration&width=80&height=80&seq=avatar-03&orientation=squarish',
                      text: '《花开的声音》完结的时候哭了好久，这个故事太美了。感谢36漫画网让我遇到这么好的作品，期待作者的新作！',
                      rating: 5,
                    },
                    {
                      name: '悬疑控先生',
                      avatar: 'https://readdy.ai/api/search-image?query=Mysterious%20anime%20style%20man%20avatar%20with%20glasses%20dark%20hair%20thoughtful%20expression%20wearing%20a%20trench%20coat%20simple%20clean%20background%20chibi%20style%20illustration&width=80&height=80&seq=avatar-04&orientation=squarish',
                      text: '暗影侦探的剧情真的绝了！每一话都反转再反转，完全猜不到下一步。36漫画网的悬疑分类做的很好，很容易找到同类型作品。',
                      rating: 5,
                    },
                    {
                      name: '日常摸鱼党',
                      avatar: 'https://readdy.ai/api/search-image?query=Funny%20anime%20style%20boy%20avatar%20with%20messy%20hair%20laughing%20expression%20wearing%20casual%20hoodie%20simple%20clean%20background%20chibi%20style%20illustration&width=80&height=80&seq=avatar-05&orientation=squarish',
                      text: '小明的日常是我每周的快乐源泉！太搞笑了，每次看完心情都变好。平台的搞笑漫画都挺不错。',
                      rating: 4,
                    },
                    {
                      name: '猫奴一号',
                      avatar: 'https://readdy.ai/api/search-image?query=Soft%20anime%20style%20girl%20avatar%20with%20short%20silver%20hair%20cat%20on%20her%20head%20peaceful%20smile%20simple%20clean%20background%20chibi%20style%20illustration&width=80&height=80&seq=avatar-06&orientation=squarish',
                      text: '猫咪咖啡馆的画风太软萌了！作为一个猫奴，里面的每一只猫咪我都好喜欢。橘猫店长是我本命！',
                      rating: 5,
                    },
                  ].map((review, i) => (
                    <div key={i} className="bg-background-50 border border-background-200 rounded-lg p-5">
                      <div className="flex items-center gap-3 mb-3">
                        <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                          <img
                            src={review.avatar}
                            alt={review.name}
                            className="w-full h-full object-cover"
                          />
                        </div>
                        <div>
                          <div className="text-sm font-medium text-foreground-900">{review.name}</div>
                          <div className="flex items-center gap-0.5">
                            {Array.from({ length: 5 }).map((_, j) => (
                              <i
                                key={j}
                                className={`text-xs ${j < review.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
                              ></i>
                            ))}
                          </div>
                        </div>
                      </div>
                      <p className="text-sm text-foreground-700 leading-relaxed">{review.text}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div id="contact" className="mb-12">
                <div className="bg-secondary-50 rounded-lg p-6 md:p-8">
                  <h2 className="text-2xl font-heading text-foreground-900 mb-6 text-center">联系我们</h2>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <h3 className="text-lg font-heading text-foreground-900 mb-4">联系方式</h3>
                      <div className="space-y-4">
                        {[
                          { icon: 'ri-mail-line', label: '电子邮箱', value: 'contact@36manhua.com' },
                          { icon: 'ri-wechat-line', label: '微信公众号', value: '洞洞杂货铺漫画' },
                          { icon: 'ri-weibo-line', label: '新浪微博', value: '@36漫画网' },
                          { icon: 'ri-bilibili-line', label: 'B站官方号', value: '36漫画网官方' },
                        ].map((item, i) => (
                          <div key={i} className="flex items-center gap-3">
                            <div className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-100 flex-shrink-0">
                              <i className={`${item.icon} text-primary-500`}></i>
                            </div>
                            <div>
                              <div className="text-xs text-foreground-500">{item.label}</div>
                              <div className="text-sm text-foreground-900 font-medium">{item.value}</div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div>
                      <h3 className="text-lg font-heading text-foreground-900 mb-4">给我们留言</h3>
                      <form
                        className="space-y-3"
                        data-readdy-form="true"
                        onSubmit={async (e) => {
                          e.preventDefault();
                          const form = e.currentTarget;
                          const honeypot = form.querySelector<HTMLInputElement>('input[name="website_alt"]');
                          if (honeypot && honeypot.value.trim()) {
                            alert('留言已提交，感谢您的反馈！');
                            form.reset();
                            return;
                          }
                          const formData = new FormData(form);
                          formData.delete('website_alt');
                          try {
                            const resp = await fetch('https://readdy.ai/api/form/d9peomli2vhsdh2d32r0', {
                              method: 'POST',
                              headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                              body: new URLSearchParams(formData as any).toString(),
                            });
                            const text = await resp.text();
                            let parsed;
                            try { parsed = JSON.parse(text); } catch { parsed = null; }
                            if (resp.ok && parsed?.code === 'OK') {
                              alert('留言已提交，感谢您的反馈！我们会尽快回复。');
                              form.reset();
                            } else {
                              const msg = parsed?.meta?.message || parsed?.message || '提交失败，请稍后重试';
                              alert(msg);
                            }
                          } catch {
                            alert('网络错误，请稍后重试');
                          }
                        }}
                      >
                        <input
                          type="text"
                          name="name"
                          placeholder="您的昵称"
                          required
                          className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                        />
                        <input
                          type="email"
                          name="email"
                          placeholder="您的邮箱"
                          required
                          className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                        />
                        <textarea
                          name="message"
                          placeholder="请输入您的留言内容..."
                          rows={4}
                          maxLength={500}
                          required
                          className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                        ></textarea>
                        <div className="honeypot-field">
                          <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                        </div>
                        <button
                          type="submit"
                          className="w-full px-6 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-label whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
                        >
                          提交留言
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}